//
export default [
    {
        field           : 'name',
        type            : 'text',
        vuetifyProps    : {
            label       : 'Nombre',
        },
        rules           : [ 'required' ],
    },
    {
        field           : 'alias_name',
        type            : 'text',
        vuetifyProps    : {
            label       : 'Alias',
        },
        rules           : [ 'required' ],
    },
    {
        field           : 'wh_family_id',
        type            : 'autocompleteObject',
        vuetifyProps    : {
            label       : 'Familia',
        },
        options         : {
            data        : [],
            text        : 'family',
            value       : 'id',
        },
        rules           : [ 'required' ],
    },
    {
        field           : 'wh_subfamily_id',
        type            : 'autocompleteObject',
        vuetifyProps    : {
            label       : 'Subfamilia',
            noDataText  : '¡ Subfamilias No encontradas!' 
        },
        options         : {
            data        : [],
            text        : 'subfamily',
            value       : 'id',
        },
        rules           : [ 'required' ],
        value           : '',
    },
    {
        field           : 'tags',
        type            : 'autocompleteObject',
        vuetifyProps    : {
            label       : 'Etiquetas',
            multiple    : true,
            chips       : true,
            deletableChips: true,
        },
        options         : {
            data        : [],
            text        : 'tag',
            value       : 'id',
        },
    },
    {
        field           : 'internal_code',
        type            : 'text',
        vuetifyProps    : {
            label       : 'Código interno',
        },
        rules           : [ 'required' ],
    },
    {
        field           : 'description',
        type            : 'textarea',
        vuetifyProps    : {
            label       : 'Descripción',
            singleLine  : true,
        },
    },
]